import { createContext, useContext, useState, useCallback } from "react";
import { TargetsLink } from "./TargetsLink";

const TargetsContext = createContext();

export const TargetsProvider = ({ children }) => {
  const [timeSlots, setTimeSlots] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const fetchRounds = useCallback(async (datetime, distance) => {
    setLoading(true);
    setError(null);
    try {
      const dateStr = datetime.split(" ")[0];
      const currentDate = new Date(dateStr);
      const cutoffDate = new Date("2025-11-02");

      // 요청할 날짜 목록
      let datesToFetch = [];

      // 2025-11-02 이전이면 11/1, 11/2 두 날짜 모두 조회
      if (currentDate <= cutoffDate) {
        datesToFetch = ["2025-11-03 00:00:00"];
      } else {
        // 2025-11-03 이후는 해당 날짜만
        datesToFetch = ["2025-11-04 00:00:00"];
      }

      // 각 날짜별로 API 호출
      const allTimeSlots = [];
      for (const date of datesToFetch) {
        const link = new TargetsLink();
        await link.request(date, distance);
        allTimeSlots.push(...link.timeSlots);
      }

      // 시간순 정렬
      allTimeSlots.sort((a, b) => {
        const timeA = new Date(a.round_schedule?.round_time);
        const timeB = new Date(b.round_schedule?.round_time);
        return timeA - timeB;
      });

      setTimeSlots(allTimeSlots);
    } catch (error) {
      console.error("Failed to fetch rounds:", error);
      setError(error.message);
      setTimeSlots([]);
    } finally {
      setLoading(false);
    }
  }, []);

  const value = {
    timeSlots,
    loading,
    error,
    fetchRounds,
  };

  return (
    <TargetsContext.Provider value={value}>{children}</TargetsContext.Provider>
  );
};

export const useTargets = () => {
  const context = useContext(TargetsContext);
  if (!context) {
    throw new Error("useTargets must be used within a TargetsProvider");
  }
  return context;
};
